import { Box, Skeleton } from '@inflearn/ds-react';

export default function CourseReviewSkeletonItem({ count }: { count?: number }) {
  if (count) {
    return (
      <>
        {Array.from({ length: count })
          .fill(1)
          .map((_, i) => (
            <Box p={20} key={i}>
              <Skeleton radius="sm" w={94} h={26} />
              <Skeleton radius="sm" w={640} h={48} mt={12} maw="100%" />
              <Skeleton radius="sm" w={200} h={18} mt={8} maw="100%" />
            </Box>
          ))}
      </>
    );
  }

  return (
    <Box p={20}>
      <Skeleton radius="sm" w={94} h={26} />
      <Skeleton radius="sm" w={640} h={48} mt={12} maw="100%" />
      <Skeleton radius="sm" w={200} h={18} mt={8} maw="100%" />
    </Box>
  );
}
